/* EMPRICS product page family data v1.3 (04/11/26, Website Options Agent, change_queue 124 and 121, Decision Box 78).
   v1.3: one accessories list beneath the code selection, read live from the register (configurator "accessories",
   sku.web_family_accessories) including Replacement engines. assets/emprics-acc.json supplies optic names, group names
   and thumbnails (assets/emprics-acc-img.json) where the register holds no image. "Accessories (n)" button beside the
   code selection. The foot-of-page "Accessories for this product" section is removed from the template.
   v1.2 (28/10/26) one icon row; v1.1 (27/10/26) live specification; v1.0 (26/10/26) icons, spec, accessories, guide.
   Requires assets/emprics-icons.js (window.EmpricsData). */
(function () {
  'use strict';
  var el = document.querySelector('[data-emp-fi]'); if (!el) return;
  var code = el.dataset.family, ACC_URL = el.dataset.acc, IMG_URL = el.dataset.accImg, SPEC_URL = el.dataset.specs, QUOTE_KEY = 'emprics_quote_list';
  var CFG_URL = 'https://glbfybjrzlzjxgezzfqh.supabase.co/functions/v1/configurator';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var getJSON = function (u) { return fetch(u).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); };

  var GROUPS = [
    ['Construction', ['Installation', 'Dimensions', 'Cut-out', 'Finish', 'Protection', 'Impact', 'Suspension', 'Mounting', 'Material', 'Weight']],
    ['Photometric', ['Luminaire output', 'Efficacy', 'Colour temperature', 'Colour rendering', 'Beam', 'Glare control', 'Optics', 'Light source']],
    ['Electrical', ['Power', 'Lamp holder', 'Control gear', 'Drive current', 'Driver', 'Emergency', 'Voltage']]
  ];

  // Live register data from the configurator on this page; null when the family is not registered or unreachable.
  function liveData() {
    return new Promise(function (resolve) {
      var S = window.EmpricsConfigurator;
      if (S && S.data && S.data[code]) { resolve(S.data[code]); return; }
      if (!document.querySelector('[data-emp-cfg]')) { resolve(null); return; }
      var t = setTimeout(function () { document.removeEventListener('emp-cfg:data', h); resolve(null); }, 25000);
      function h(e) {
        if (!e.detail || e.detail.family !== code) return;
        clearTimeout(t); document.removeEventListener('emp-cfg:data', h); resolve(e.detail.data);
      }
      document.addEventListener('emp-cfg:data', h);
    });
  }

  // v1.3: live accessories (accessories and replacement engines) from the register; null when unreachable.
  function liveAccessories() {
    return liveData().then(function (live) {
      if (live && Array.isArray(live.accessories)) return live;
      return getJSON(CFG_URL + '?family=' + encodeURIComponent(code)).then(function (d) { return d && Array.isArray(d.accessories) ? d : (live || null); });
    });
  }

  function specTable(rows) {
    var used = {}, html = '';
    GROUPS.forEach(function (g) {
      var r = rows.filter(function (x) { return g[1].some(function (k) { return x[0].indexOf(k) === 0; }); });
      r.forEach(function (x) { used[x[0]] = 1; });
      if (r.length) html += block(g[0], r);
    });
    var rest = rows.filter(function (x) { return !used[x[0]]; });
    if (rest.length) html += block('Further data', rest);
    return html;
  }
  function block(title, rows) {
    return '<div class="emprics-specs__block"><div class="emprics-specs__block-head">' + esc(title) + '</div><table class="emprics-specs__table">' +
      rows.map(function (x) { return '<tr><th>' + esc(x[0]) + '</th><td>' + esc(x[1]) + '</td></tr>'; }).join('') + '</table></div>';
  }

  function addToQuote(item, btn) {
    var items; try { items = JSON.parse(localStorage.getItem(QUOTE_KEY) || '[]'); } catch (e) { items = []; }
    var f = items.filter(function (i) { return i.handle === item.handle; })[0];
    if (f) f.qty = (f.qty || 1) + 1; else { item.qty = 1; item.ref = ''; items.push(item); }
    try { localStorage.setItem(QUOTE_KEY, JSON.stringify(items)); } catch (e) {}
    if (window.EmpricsQuote && window.EmpricsQuote.updateBadges) window.EmpricsQuote.updateBadges();
    var t = btn.textContent; btn.textContent = 'Added'; btn.classList.add('is-added');
    setTimeout(function () { btn.textContent = t; btn.classList.remove('is-added'); }, 1400);
  }

  // v1.3: merge the live list with the static file. Rows: [code, description, group, image key, image url].
  function accRows(stat, live) {
    var sa = (stat && stat.a) || [], byCode = {};
    sa.forEach(function (a) { byCode[a[0]] = a; });
    if (!live || !Array.isArray(live.accessories)) return sa.map(function (a) { return [a[0], a[1], a[2], a[3], '']; });
    var rows = live.accessories.map(function (a) {
      var s = byCode[a.sku];
      var grp = a.type === 'RE' ? 'Replacement engines' : (s ? s[2] : (a.type_label || 'Accessories'));
      return [a.sku, a.description || (s ? s[1] : ''), grp, s ? s[3] : '', a.image || ''];
    });
    // Replacement engines always last.
    return rows.filter(function (r) { return r[2] !== 'Replacement engines'; }).concat(rows.filter(function (r) { return r[2] === 'Replacement engines'; }));
  }
  function optics(stat, live) {
    if (stat && stat.o && stat.o.length) return stat.o.map(function (o) { return o[1]; });
    var l = (live && live.labels) || [];
    return l.filter(function (x) { return x.p === 'optic' && x.c && x.c !== '00' && x.l; })
      .sort(function (a, b) { return (a.s || 0) - (b.s || 0); }).map(function (x) { return x.l; });
  }

  function accPanel(opt, rows, imgs) {
    var handle = code.toLowerCase(), image = el.dataset.image || '';
    var optHtml = opt.length ? '<div class="efa__optics"><p class="efa__k">Optics offered</p><ul class="efa__chips">' +
      opt.map(function (o) { return '<li>' + esc(o) + '</li>'; }).join('') + '</ul><p class="efa__hint">Select the optic in the configurator above; it forms part of the product code.</p></div>' : '';
    var groups = {}, names = [];
    rows.forEach(function (a) { if (!groups[a[2]]) { groups[a[2]] = []; names.push(a[2]); } groups[a[2]].push(a); });
    var acc = names.map(function (g, gi) {
      return '<details class="efa__grp"' + (gi === 0 && names.length < 4 ? ' open' : '') + '><summary>' + esc(g) + ' <span>(' + groups[g].length + ')</span></summary>' +
        groups[g].map(function (a) {
          var src = a[4] || (a[3] && imgs && imgs[a[3]]);
          return '<div class="efa__row">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="efa__noimg" aria-hidden="true"></span>') +
            '<div class="efa__txt"><p class="efa__code">' + esc(a[0]) + '</p><p class="efa__desc">' + esc(a[1]) + '</p></div>' +
            '<button type="button" class="efa__add" data-code="' + esc(a[0]) + '" data-desc="' + esc(a[1]) + '">Add to Quote</button></div>';
        }).join('') + '</details>';
    }).join('');
    if (!optHtml && !acc) return null;
    var box = document.createElement('div'); box.className = 'efa'; box.id = 'emp-accessories';
    box.innerHTML = '<p class="efa__title">Optics and accessories</p>' + optHtml + (acc ? '<p class="efa__k">Accessories and parts</p>' + acc : '');
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.efa__add'); if (!b) return;
      addToQuote({ handle: handle + '?sku=' + b.dataset.code, title: b.dataset.code, sku: b.dataset.code, image: image, type: 'Accessory', description: b.dataset.desc }, b);
    });
    return box;
  }

  // v1.3: "Accessories (n)" button beside the code selection; jumps to the list and opens the first group.
  function jumpButton(n, panel) {
    if (!n || document.querySelector('.efa-jump')) return;
    if (!document.getElementById('efa-jump-css')) {
      var st = document.createElement('style'); st.id = 'efa-jump-css';
      st.textContent = '.efa-jump{display:inline-flex;align-items:center;gap:8px;min-height:40px;margin:0 0 16px;padding:8px 16px;border:1px solid var(--emprics-green,#1F5744);border-radius:999px;background:var(--emprics-green,#1F5744);color:#fff;font:inherit;font-size:.9rem;font-weight:600;text-decoration:none;cursor:pointer}' +
        '.efa-jump:hover{filter:brightness(1.15)}.efa-jump:focus-visible{outline:2px solid #fff;outline-offset:2px}#emp-accessories{scroll-margin-top:96px}';
      document.head.appendChild(st);
    }
    var a = document.createElement('a'); a.className = 'efa-jump'; a.href = '#emp-accessories';
    a.textContent = 'Accessories (' + n + ')';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var d = panel.querySelector('details.efa__grp'); if (d) d.open = true;
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    var cfg = document.getElementById('emp-cfg');
    var head = cfg && cfg.querySelector('h2, h3');
    if (head && head.parentNode) head.parentNode.insertBefore(a, head.nextSibling);
    else if (cfg) cfg.insertBefore(a, cfg.firstChild);
    else panel.parentNode.insertBefore(a, panel);
  }

  function applySpec(sp) {
    var data = document.querySelector('.emprics-specs__data');
    if (sp && sp.s && sp.s.length && data) {
      data.innerHTML = specTable(sp.s) + (sp.a ? '<div class="emprics-specs__block emprics-specs__block--wide"><div class="emprics-specs__block-head">Applications</div><table class="emprics-specs__table"><tr><th>Suited to</th><td>' + esc(sp.a) + '</td></tr></table></div>' : '');
      data.setAttribute('data-source', sp.live ? 'register-live' : 'register');
    }
    // Header chips (DIM, CUTOUT, IP, MOUNT) restated from the register; chips the register cannot support are removed.
    if (sp && sp.s && sp.s.length) {
      var val = function (k) { var r = sp.s.filter(function (x) { return x[0] === k; })[0]; return r ? r[1] : ''; };
      var map = { DIM: val('Dimensions'), CUTOUT: val('Cut-out'), IP: val('Protection').replace(/IP/g, ''), MOUNT: val('Installation') };
      Array.prototype.forEach.call(document.querySelectorAll('.emprics-pdp__spec-chip'), function (c) {
        var lab = c.querySelector('.emprics-pdp__spec-label'); if (!lab) return;
        var k = lab.textContent.trim().toUpperCase();
        if (!(k in map)) return;
        if (!map[k]) { c.remove(); return; }
        var v = c.querySelector('.emprics-pdp__spec-val') || lab.nextElementSibling;
        if (v) v.textContent = map[k];
      });
    }
  }

  var done = false;
  function run() {
    if (!window.EmpricsData || done) return;
    done = true;
    Promise.all([window.EmpricsData.ready(), getJSON(SPEC_URL), getJSON(ACC_URL)]).then(function (r) {
      var D = r[0], specs = r[1] || {}, accAll = r[2] || {}, f = D.fam(code);
      // 1. icons
      var cover = f ? f.cover : ['eco-design', 'warranty-7'], spec = f ? f.spec : ['eco-design', 'warranty-7'];
      var head = document.querySelector('.emprics-pdp__certs');
      // v1.2 (28/10/26, David): one icon row only, under Key features; the row beside the options and accessories is removed.
      if (head) { head.innerHTML = ''; head.style.setProperty('display', 'none', 'important'); }
      var title = document.querySelector('.emprics-specs__section-title');
      if (title && !document.querySelector('.emp-fi-spec') && spec.length) {
        var box = document.createElement('div'); box.className = 'emp-fi-spec';
        box.innerHTML = '<p class="emp-fi-spec__label">Key features</p>' + window.EmpricsData.stripSync(D.icons, spec, {});
        title.parentNode.insertBefore(box, title.nextSibling);
      }
      // 2. specification: live register rows first, the theme data file as the fallback
      var stat = specs[code];
      applySpec(stat);
      liveData().then(function (live) {
        if (live && live.spec && live.spec.length) applySpec({ s: live.spec, a: stat && stat.a, live: true });
      });
      // 4. product guide first among the downloads
      var g = D.guides[code], dls = document.querySelector('.emprics-specs__downloads');
      if (g && dls && !dls.querySelector('.efa-guide')) {
        var a = document.createElement('a'); a.className = 'emprics-specs__dl-card efa-guide'; a.href = g[1]; a.target = '_blank'; a.rel = 'noopener';
        a.innerHTML = '<div class="emprics-specs__dl-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></div><div><div class="emprics-specs__dl-name">Product guide REV ' + esc(g[0]) + '</div><div class="emprics-specs__dl-type">PDF</div></div>';
        dls.insertBefore(a, dls.firstChild);
        var dsl = document.querySelector('.emprics-pdp__datasheet-link');
        if (dsl) { dsl.href = g[1]; Array.prototype.forEach.call(dsl.childNodes, function (n) { if (n.nodeType === 3 && /Datasheet/i.test(n.textContent)) n.textContent = ' Download product guide'; }); }
        Array.prototype.forEach.call(dls.querySelectorAll('.emprics-specs__dl-card:not(.efa-guide)'), function (c) {
          if (/Product Datasheet/i.test(c.textContent)) c.remove();
        });
      }
      // 3. optics and accessories (v1.3: live register list, static file for optics, groups and thumbnails)
      var ad = accAll[code];
      liveAccessories().then(function (live) {
        var rows = accRows(ad, live), opt = optics(ad, live);
        if (!rows.length && !opt.length) return;
        var needImg = rows.some(function (x) { return x[3] && !x[4]; });
        (needImg ? getJSON(IMG_URL) : Promise.resolve(null)).then(function (imgs) {
          var panel = accPanel(opt, rows, imgs); if (!panel) return;
          var anchor = document.getElementById('emp-cfg');
          if (anchor && anchor.classList.contains('emp-cfg--side')) anchor.parentNode.insertBefore(panel, anchor.nextSibling);
          else {
            var info = document.querySelector('.emprics-pdp__summary') || document.querySelector('.emprics-pdp__certs');
            if (info) info.parentNode.insertBefore(panel, info.nextSibling);
          }
          jumpButton(rows.length, panel);
        });
      });
    }).catch(function () {});
  }
  function start() {
    var tries = 0;
    (function wait() {
      var c = document.getElementById('emp-cfg');
      if (!c || c.classList.contains('emp-cfg--side') || !c.isConnected || ++tries > 40) run(); else setTimeout(wait, 150);
    })();
  }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();